import getConfig from '../app/config';
import './get-started.scss';

const GetStarted = ({ registerUrl }: any) => {

    const { beta: isBeta } = getConfig() as any;

    return (
        <div className="marketing-get-started">
            <div className="marketing-get-started-box">
                <div className="marketing-get-started-content">
                    <div className="get-started-title">Get started for free</div>
                    <div className="get-started-register">Register today to try Filmanize for free</div>
                    <div className="get-started-register">Check out the <a href="https://www.youtube.com/watch?v=eOror_QjPZM&list=PLEGzR_hAtu4Jxatzc52ewuIuzgUHZIAKU&index=1" target="_blank">video tutorials</a></div>
                    <a href={registerUrl} className="button try-beta-button">Try {isBeta ? "the beta" : "for free"} now</a>
                </div>
            </div>
        </div>
    )
}

export default GetStarted;